import Redirecting from './Redirecting'

export default Redirecting